// Shared read hook for courier escalations. Subscribes once per mount and exposes
// fast lookups by orderId and by 10-digit mobile so any module (Order row, Customer
// Profile, Tracking, Telecaller) can surface escalations without its own query.
import { useState, useEffect, useMemo } from 'react';
import { CourierEscalationService } from '../services/CourierEscalationService';
import { isActiveStatus } from '../logic/courierEscalation';

const key10 = (m) => String(m || '').replace(/\D/g, '').slice(-10);

export function useCourierEscalations() {
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = CourierEscalationService.subscribe((list) => { setAll(list); setLoading(false); });
    return () => unsub && unsub();
  }, []);

  const { byOrder, byMobile } = useMemo(() => {
    const bo = {}; const bm = {};
    for (const e of all) {
      if (e.orderId) (bo[e.orderId] = bo[e.orderId] || []).push(e);
      const m = key10(e.mobile);
      if (m) (bm[m] = bm[m] || []).push(e);
    }
    return { byOrder: bo, byMobile: bm };
  }, [all]);

  const pickActive = (list = []) => list.find(e => isActiveStatus(e.status)) || null;

  return {
    all, loading, byOrder, byMobile,
    forOrder: (orderId) => byOrder[orderId] || [],
    activeForOrder: (orderId) => pickActive(byOrder[orderId]),
    forMobile: (mobile) => byMobile[key10(mobile)] || [],
    activeForMobile: (mobile) => pickActive(byMobile[key10(mobile)]),
  };
}

export default useCourierEscalations;
